module.exports = "<mat-sidenav-container>\r\n    <sa-menu *ngIf=\"!isLoginRoute()\"></sa-menu>\r\n    <div class=\"content\" [ngClass]=\"{'login-content': isLoginRoute()}\" flex>\r\n      <router-outlet></router-outlet>\r\n    </div>\r\n</mat-sidenav-container>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 1175
// module chunks = 0